function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 5 L100 85 L195 5",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretdown);
export default __webpack_public_path__ + "static/media/caretdown.7f483d6e35a3e11baec58249a717bea0.svg";
export { ForwardRef as ReactComponent };